var _desc, _defs, _rect, _circle, _circle2, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiPlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 500,
    viewBox: "0 0 800 500",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "AI Project Placeholder") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Placeholder image for AI projects")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0b1220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1f2a44"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 500,
    fill: "url(#bg)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 620,
    cy: 140,
    r: 90,
    fill: "#00d1b2",
    opacity: 0.35
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 360,
    r: 120,
    fill: "#3ea0ff",
    opacity: 0.25
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 90,
    width: 660,
    height: 320,
    rx: 28,
    fill: "#0e172a",
    opacity: 0.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#e5e7eb",
    fontFamily: "Arial, sans-serif",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 230,
    fontSize: 44,
    fontWeight: 700
  }, "AI Project"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 280,
    fontSize: 22,
    opacity: 0.8
  }, "Placeholder Image"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiPlaceholder);
export default __webpack_public_path__ + "static/media/ai-placeholder.33d4613a2959f1f870ceab9b492755c9.svg";
export { ForwardRef as ReactComponent };